<template>
  <v-btn
    v-bind="$attrs"
    v-on="$listeners"
    depressed
    class="h-100 text-capitalize"
    color="primary"
    :class="btnClass"
  >
    <v-icon v-if="icon" :size="iconSize" :color="iconColor" :class="iconClass">
      {{ icon }}
    </v-icon>
    {{ name }}
  </v-btn>
</template>

<script>
import BaseTooltip from "@/components/BaseComponents/BaseTooltip.vue";
export default {
  components: {
    BaseTooltip,
  },
  props: {
    tooltipMessage: {
      default: null,
    },
    btnClass: {
      default: "rounded-lg",
    },
    iconClass: {
      default: "mr-2",
    },
    iconColor: {
      default: "white",
    },
    icon: {
      default: null,
    },
    name: {
      default: null,
    },
    iconSize: {
      default: "small",
    },
  },
};
</script>